import { useEffect, useMemo } from 'react';

import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Grid, IconButton } from '@mui/material';
import { Spacing } from 'src/styles';

interface FilePreviewProps {
  file: File;
  onRemove: () => void;
}

export const FilePreview = ({ file, onRemove }: FilePreviewProps) => {
  const fileUrl = useMemo(() => {
    if (file) {
      return URL.createObjectURL(file);
    }

    return undefined;
  }, [file]);

  const _onRemove = (event: React.MouseEvent) => {
    event.stopPropagation();
    onRemove();
  };

  useEffect(() => {
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);

  return (
    <Grid item className={Spacing.my4}>
      <IconButton aria-label='Remove file' size='small' onClick={_onRemove}>
        <RemoveCircleIcon fontSize='medium' color='error' />
      </IconButton>
      <a href={fileUrl} target='_blank' rel='noopener noreferrer'>
        {file.name}
      </a>
    </Grid>
  );
};
